import Acorns from 'assets/images/banks/Acorns.svg'
import Ally from 'assets/images/banks/Ally.svg'
import BankofAmerica from 'assets/images/banks/BankofAmerica.svg'
import BBT from 'assets/images/banks/BB&T.svg'
import CapitalOne from 'assets/images/banks/CapitalOne.svg'
import Chase from 'assets/images/banks/Chase.svg'
import CitiBank from 'assets/images/banks/CitiBank.svg'
import Citizens from 'assets/images/banks/Citizens.svg'
import NavyFederal from 'assets/images/banks/NavyFederal.svg'
import PNC from 'assets/images/banks/PNC.svg'
import Regions from 'assets/images/banks/Regions.svg'
import Robinhood from 'assets/images/banks/Robinhood.svg'
import Suntrust from 'assets/images/banks/Suntrust.svg'
import TD from 'assets/images/banks/TD.svg'
import USAA from 'assets/images/banks/USAA.svg'
import USBank from 'assets/images/banks/USBank.svg'
import Venmo from 'assets/images/banks/Venmo.svg'
import WellsFargo from 'assets/images/banks/WellsFargo.svg'
import BankIcon from 'components/Icons/Bank'
import palette from 'components/palette'
import React from 'react'
import styled from 'styled-components'

type Props = {
  name?: string
}

const Img = styled.img``

const BankLogo = ({ name }: Props) => {
  if (!name) return <BankIcon fill={palette.blue600} size='32' />

  switch (name) {
    case 'Acorns':
      return <Img src={Acorns} />
    case 'Ally':
    case 'Ally Bank':
      return <Img src={Ally} />
    case 'Bank of America':
      return <Img src={BankofAmerica} />
    case 'Bank of America (Fidelity NetBenefits)':
      return <Img src={BankofAmerica} />
    case 'BB&T':
      return <Img src={BBT} />
    case 'Capital One':
      return <Img src={CapitalOne} />
    case 'Chase':
      return <Img src={Chase} />
    case 'Citi Bank':
      return <Img src={CitiBank} />
    case 'Citizens':
      return <Img src={Citizens} />
    case 'Citizens Bank of Philadelphia':
      return <Img src={Citizens} />
    case 'Citizens State Bank (WI)':
      return <Img src={Citizens} />
    case 'Citizens Tri-County Bank':
      return <Img src={Citizens} />
    case 'Navy Federal':
      return <Img src={NavyFederal} />
    case 'Navy Federal Credit Union':
      return <Img src={NavyFederal} />
    case 'PNC':
      return <Img src={PNC} />
    case 'PNC Bank':
      return <Img src={PNC} />
    case 'Regions':
      return <Img src={Regions} />
    case 'Regions Bank':
      return <Img src={Regions} />
    case 'Regions Bank (Mortgage)':
      return <Img src={Regions} />
    case 'Regions Bank - Credit Cards':
      return <Img src={Regions} />
    case 'Regions Retirement 24/7':
      return <Img src={Regions} />
    case 'Robinhood':
      return <Img src={Robinhood} />
    case 'Suntrust':
      return <Img src={Suntrust} />
    case 'SunTrust Bank':
      return <Img src={Suntrust} />
    case 'TD':
      return <Img src={TD} />
    case 'TD Canada Trust':
      return <Img src={TD} />
    case 'US Bank':
      return <Img src={USBank} />
    case 'USAA':
      return <Img src={USAA} />
    case 'Venmo':
      return <Img src={Venmo} />
    case 'Wells Fargo':
      return <Img src={WellsFargo} />
    case 'Wells Fargo Asset Management':
      return <Img src={WellsFargo} />
    case 'Wells Fargo Retirement Services':
      return <Img src={WellsFargo} />
    default:
      return <BankIcon fill={palette.blue600} size='32' />
  }
}

export default BankLogo
